import { useTranslation } from "react-i18next";

import { Builder } from "@builder.io/react";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { selectSelectedCurrency } from "../../../../../store/user";
import SelectCurrency from "../../../../general/selectCurrency";
import useHandleAddProduct from "../../../../../utils/handleAddProduct";
import { selectProducts } from "../../../../../store/products";
import useCart from "../../../../../hooks/cart/useCart";
import { openSheet } from "../../../../../store/sheetToggler";
import ShowCurrencies from "../../../../../utils/showCurrencies";
import getSymbolFromCurrency from "currency-symbol-map";
import ProgressBar from "./progressBar";
import {
  getCreatorCodesWithDates,
} from "../../../../../pages/MATWAppeal/dates";
import services from "../../../../../services";
import ConvertUSD from "../../../../../utils/convertUSD";
import { formatCompactCurrency } from "../../../../../utils/formatCompactCurrency";
import Skeleton from "react-loading-skeleton";
import { calculateCampaigns } from "../../../../../pages/MATWAppeal/campaignCalculation";
import { MdAdd } from "react-icons/md";
import { HiMinus, HiPlus } from "react-icons/hi";

const SingleProductWidget = ({
  defaultProduct,
  addToCart,
  mode = "one-off",
  defaultPrice,
  showRaised = true,
  isSquared = false,
  campaign = 'gaza-bakery',
  showProgressBar = true,
  inputContainerClasses = ""
}) => {
  const [addProduct] = useHandleAddProduct();
  const products = useSelector((state) => selectProducts(state));
  const [isLoaded, setIsLoaded] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState({
    creator: defaultProduct?.creator,
    label: defaultProduct?.label,
    value: defaultProduct?.value,
  });

  const { i18n } = useTranslation();
  const lang = i18n.language;
  const selectedCurrencyStore = useSelector(selectSelectedCurrency);
  const [currentCurrency, setCurrentCurrency] = useState();
  const [productAmount, setProductAmount] = useState(defaultPrice || 300);

  const dispatch = useDispatch();
  const { handleAddToGiving: handleAddToGivingCart } = useCart();
  const [selectedRecurring, setSelectedRecurring] = useState({
    value: mode || "one-off",
  });

  const [cachedGoal, setCachedGoal] = useState(null);
  const [cachedRaised, setCachedRaised] = useState(null);
  const [cachedSupporters, setCachedSupporters] = useState(null);


  const [currentProduct, setCurrentProduct] = useState();
  const [allOrders, setAllOrders] = useState([]);
  const [isOrdersLoaded, isSetOrdersLoaded] = useState(false)


  const formatCurrencyLabel = (currency) => {
    if (!currency) return "";

    const uppercase = currency.toUpperCase();

    switch (uppercase) {
      case "MYR":
      case "CAD":
      case "SGD":
        return '';
      default:
        return getSymbolFromCurrency(uppercase) || uppercase;
    }
  };

  const handleAddNewProduct = () => {
    let tempProduct = selectedProduct;
    let customAmount = Number(productAmount)
      ? Number(productAmount)
      : Number(productAmount)
        ? Number(productAmount)
        : 1;
    tempProduct = Object.assign({}, tempProduct, {
      quantity: customAmount,
      recurring: selectedRecurring.value,
    });

    if (addToCart) {
      handleAddToGivingCart(tempProduct, "custom");
      dispatch(openSheet());
    } else {
      addProduct({ product: tempProduct, currency: currentCurrency });
    }
  };

  const handleAmountKeyDown = (e) => {
    if (["e", "E", "+", "-", "."].includes(e.key)) {
      e.preventDefault();
    }
  };

  const handleAmountChange = (e) => {
    const regex = /^$|^[1-9][0-9]*$/;
    if (regex.test(e.target.value)) {
      setProductAmount(e.target.value);
    }
  };

  /* ------------------------------- Start hooks ------------------------------ */

  const squareEdges = isSquared ? 'rounded-none' : 'rounded-md';

  const getAllProducts = (products) => {
    if (!products) return;

    products.forEach((item) => {
      item.sub_categories.forEach((inner_item) => {
        inner_item.products.forEach((inner_item_product) => {
          if (Number(inner_item_product.status) === 1) {
            if (inner_item_product.creator === defaultProduct.creator) {
              setSelectedProduct(inner_item_product);
            }
          }
        });
      });
    });

    setIsLoaded(true);
  };

  useEffect(() => {
    products && Object.keys(products).length && getAllProducts(products);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [products]);
  useEffect(() => {
    setCurrentProduct(null);
    selectedCurrencyStore && getLatestOrdersVersion3();
    selectedCurrencyStore
      ? setCurrentCurrency(selectedCurrencyStore)
      : setCurrentCurrency("AUD");
      
  }, [selectedCurrencyStore]);

  //   Donors

  const getLatestOrdersVersion3 = async () => {
    let req = {
      products: getCreatorCodesWithDates(),
      currency: selectedCurrencyStore,
    };
    try {
      const response = await services.getLatestOrdersV3(req);
      console.log("response donors", response);
      setAllOrders(response.data);
    } catch (error) {
      console.error("error========", error);
    }
  };

  useEffect(() => {
    if (allOrders && products && Object.keys(products).length) {
      // getAllProducts(allOrders);
      const { currentProduct } = calculateCampaigns({
        products,
        _prds: allOrders,
        selectedCurrencyStore,
        campaign,
      });
      // Now you update your React state easily:
      setCurrentProduct(currentProduct);
    }
    
  }, [allOrders, products]);

  useEffect(() => {
    if (!currentProduct) return;
  
    const goal = currentProduct?.goal;
    const raised = currentProduct?.totalRaised || currentProduct?.total_sale;
    const supporters = currentProduct?.totalSupporters || currentProduct?.total_count;
  
    const isReady = !!(goal && raised && supporters);
  
    if (isReady) {
      if (goal !== cachedGoal) setCachedGoal(goal);
      if (raised !== cachedRaised) setCachedRaised(raised);
      if (supporters !== cachedSupporters) setCachedSupporters(supporters);
  
      setTimeout(() => isSetOrdersLoaded(true), 100);
    }
  }, [currentProduct]);
  

  return (
    <div className="bg-[#EAF7FF]">
      <div className="flex gap-4 flex-col lg:flex-row lg:items-center gap-3">
        {/* Left column */}
        {isOrdersLoaded && showRaised ? (
          <div className="flex items-center gap-3 text-center order-2 lg:order-1">
            <div className={`flex items-center gap-1 bg-white p-2 md:p-3 ${squareEdges} text-sm md:text-base text-[#00A3DA] font-bold font-inter whitespace-nowrap w-full`}>
              {ShowCurrencies(
                    currentCurrency,
                    Math.round(
                      currentProduct?.totalRaised || currentProduct?.total_sale || cachedRaised,
                    ),
                    false,
                  )}
              of{" "}
              {formatCompactCurrency(
                Math.round(
                  ConvertUSD(
                    currentCurrency,
                    currentProduct?.goal || cachedGoal,
                    false,
                  ),
                ),
                currentCurrency === "USD" ? "$" : "",
              )} {" "}
              Raised
            </div>
            <div className={`bg-white p-2 md:p-3 ${squareEdges} text-sm md:text-base text-[#00A3DA] font-bold font-inter whitespace-nowrap w-full`}>
              {currentProduct
                ? currentProduct?.totalSupporters || currentProduct?.total_count
                : cachedSupporters}{" "}
              Supporters
            </div>
          </div>
        ) : showRaised ?
        <div className={`flex items-center gap-3 text-center order-2 lg:order-1 min-w-[300px] bg-white h-[48px] px-3 pb-1 ${squareEdges}`}>
            <Skeleton height={32} containerClassName="flex-1 w-full" baseColor="#EAF7FF"/>
            <Skeleton height={32} containerClassName="flex-1 w-full" baseColor="#EAF7FF"/>
        </div> : null
        }
        <div
          className={`w-full flex gap-3 flex-col lg:flex-row order-1 lg:order-2`}
        >
          <div className={`bg-white flex ${squareEdges} flex-1`}>
            {isOrdersLoaded ? (
            <div className="w-full min-w-[120px] flex-1 lg:flex-[0_0_120px] select-gaza-bakery">
              <SelectCurrency
                onChangeCurrency={(e) => setCurrentCurrency(e.value)}
                classNamePrefix="orphan_select"
              />
            </div>
            ) : (
            <div className={`w-full min-w-[120px] flex-1 lg:flex-[0_0_120px] flex items-center justify-center bg-white h-[48px] px-3 pb-1 ${squareEdges}`}>
                <Skeleton height={32} containerClassName="flex-1 w-full" baseColor="#EAF7FF"/>
            </div>
            )}
            {isOrdersLoaded ? (
            <div className={`flex items-center justify-center sm:justify-between gap-2 lg:gap-5 w-full flex-1 lg:flex-auto px-2 ${inputContainerClasses}`}>
              <button
                className={`bg-[#01A7E1] h-7 max-w-[28px] min-w-[28px] lg:h-8 w-full lg:max-w-[32px] ${squareEdges} text-white font-bold text-[20px] flex items-center justify-center`}
                onClick={() =>
                  setProductAmount(
                    Number(productAmount) > 0 ? Number(productAmount) - 1 : "",
                  )
                }
              >
                <HiMinus/>
              </button>
              <div className="flex items-center max-w-max">
                <span className="font-inter font-bold text-[#00A3DA]">
                  {formatCurrencyLabel(currentCurrency)}
                </span>
                <input
                  value={productAmount}
                  className={`${productAmount <= 0 ? "sm:w-[12ch]" : "sm:w-[5ch]"} transition-all duration-300 ease-in-out p-1 sm:p-2 text-center text-[#00A3DA] font-inter font-bold ${squareEdges} focus:outline-none focus:ring-1 focus:ring-transparent focus:border-transparent max-w-[108px] sm:max-w-[200px]`}
                  type="number"
                  placeholder="Enter amount"
                  min={"0"}
                  onKeyDown={handleAmountKeyDown}
                  onChange={handleAmountChange}
                  style={{
                    width: `calc(${String(productAmount).length > 0 ? String(productAmount).length + "ch + 20px" : "12ch"})`
                  }}
                />
              </div>
              <button
                className={`bg-[#01A7E1] h-7 max-w-[28px] min-w-[28px] sm:h-8 w-full sm:max-w-[32px] ${squareEdges} text-white font-bold text-[20px] flex items-center justify-center`}
                onClick={() => setProductAmount(Number(productAmount) + 1)}
              >
                <HiPlus />
              </button>
            </div>
              
            ) : (
              <div className={`flex items-center justify-between gap-5 w-full bg-white h-[48px] px-3 pb-1 ${squareEdges}`}>
                <Skeleton height={32} containerClassName="flex-1 w-full" baseColor="#EAF7FF"/>
              </div>
            )}
          </div>
          {isOrdersLoaded ? (
            <div className="min-w-[220px]">
              <button
                className={`text-white w-full font-inter font-bold text-lg transition-all duration-200 flex items-center justify-center px-3 min-h-[42px] h-full ${squareEdges} ${
                  isLoaded ? "bg-[#f60362]" : "bg-stone-300 cursor-not-allowed"
                }`}
                onClick={handleAddNewProduct}
              >
                Donate Now
              </button>
            </div>
            
          ) : (
            <div className={`min-w-[220px] flex items-center justify-center bg-white h-[48px] px-3 pb-1 ${squareEdges}`}>
                <Skeleton height={32} containerClassName="flex-1 w-full" baseColor="#EAF7FF"/>
            </div>
          )}
        </div>
      </div>

      {/* Progressbar */}
      <div className="mt-8 min-h-[60px] ">
        <ProgressBar
          goal={currentProduct?.goal}
          raised={currentProduct?.totalRaised}
          loader={isOrdersLoaded}
          currentCurrency={currentCurrency}
          isSquared={isSquared}
          showProgressBar={showProgressBar}
        />
      </div>
    </div>
  );
};

Builder.registerComponent(SingleProductWidget, {
  name: "SingleProductWidget",
  inputs: [
    {
      name: "defaultPrice",
      type: "number",
    },
    {
      name: "campaign",
      type: "string",
      defaultValue: 'gaza-bakery',
      helperText: "Enter campaign name",
      hideFromUI: false,
    },
    {
      name: "addToCart",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Add to side cart or navigate to checkout",
    },
    {
      name: "showRaised",
      type: "boolean",
      defaultValue: true,
      friendlyName: "hide or show the raised items boxes",
    },
    {
      name: "showProgressBar",
      type: "boolean",
      defaultValue: true,
      friendlyName: "hide or show the the progress bar",
    },
    {
      name: "isSquared",
      type: "boolean",
      defaultValue: false,
      friendlyName: "Sharp Widget Edges"
    },
    {
      name: "defaultProduct",
      type: "object",
      defaultValue: {
        creator: "DD-ZK-PAL-25-00",
        label: "Give Zakat Now (Zakat Al Mal)",
        value: 751,
      },
      subFields: [
        {
          name: "creator",
          type: "string",
          helperText: "Enter creator ID",
          required: true,
          hideFromUI: false,
        },
        {
          name: "label",
          type: "string",
          helperText: "Enter label",
          required: true,
          hideFromUI: false,
        },
        {
          name: "value",
          type: "number",
          helperText: "Enter value",
          required: true,
          hideFromUI: false,
        },
      ],
    },
    {
      name: 'inputContainerClasses',
      type: 'string',
      friendlyName: 'Tailwind classes for input contaienr',
    },
    {
      name: "mode",
      type: "enum",
      friendlyName: "Donation Mode",
      helperText: "Select how often the donation should recur.",
      enum: ["one-off", "week", "month"],
      enumLabels: ["Single", "Weekly", "Monthly"],
      defaultValue: "one-off",
    },
  ],
});

export default SingleProductWidget;
